Modernizr.testFlash = function() {
  var e, fo, hasFlash;
  hasFlash = false;
  try {
    fo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
    if (fo) {
      hasFlash = true;
    }
  } catch (error) {
    e = error;
    if (navigator.mimeTypes["application/x-shockwave-flash"] !== 'undefined') {
      hasFlash = true;
    }
  }
  if (hasFlash === false) {
    return $('#merchant-video').hide();
  }
};

$(function() {
  return Modernizr.testFlash();
});

